//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const yourBiggestConcern = useStore((state) => state.yourBiggestConcern);
  const setYourBiggestConcern = useStore((state) => state.setYourBiggestConcern);
  const [next, setNext] = useState(yourBiggestConcern.length > 0);

  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setYourBiggestConcern(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2' style={{ padding: '0px 20px' }}>
          {t('onboarding.yourBiggestConcern.title')}
        </Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={yourBiggestConcern} onChange={handleChange}>
          <MultiOption value={'Hot flashes / Night sweats'}>
            <span>😰</span> {t('onboarding.yourBiggestConcern.options.hotFlashes')}
          </MultiOption>
          <MultiOption value={'Weight gain'}>
            <span>⚖️</span> {t('onboarding.yourBiggestConcern.options.weightGain')}
          </MultiOption>
          <MultiOption value={'Trouble sleeping'}>
            <span>🌙</span> {t('onboarding.yourBiggestConcern.options.troubleSleeping')}
          </MultiOption>
          <MultiOption value={'Anxiety / Irritability'}>
            <span>😣</span> {t('onboarding.yourBiggestConcern.options.anxiety')}
          </MultiOption>
          <MultiOption value={'Fatigue / Low energy'}>
            <span>🔋</span> {t('onboarding.yourBiggestConcern.options.fatigue')}
          </MultiOption>
          <MultiOption value={'Memory issues'}>
            <span>🧠️</span> {t('onboarding.yourBiggestConcern.options.memoryIssues')}
          </MultiOption>
          <MultiOption value={'Low libido'}>
            <span>💔 </span> {t('onboarding.yourBiggestConcern.options.lowLibido')}
          </MultiOption>
          <MultiOption value={'Dry skin / Hair changes'}>
            <span>💇‍♀️</span> {t('onboarding.yourBiggestConcern.options.drySkin')}
          </MultiOption>
          <MultiOption value={'Joint pain or stiffness'}>
            <span>🦴</span> {t('onboarding.yourBiggestConcern.options.jointPain')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.yourBiggestConcern.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'your-biggest-concern',
              answer: yourBiggestConcern.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
